export default class NoPricingError extends Error {}